import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Senior Software Engineer",
          ".NET Core 8",
          "Clean architecture",
          "DDD",
          "Design patterns ( Singleton, Factory, Repository ) Redis, and RabbitMQ.",
          "PHP Laravel Symfony Developer",
          "Vuejs Developer",
          "Reactjs Developer",
          "Problem Solver"
          
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 100,
      }}
    />
  );
}

export default Type;
